import { useQuery } from '@tanstack/react-query'
import { useApiToken } from './useApiToken'
import { analyticsApi } from '../lib/api/analytics'

export function useAnalytics(days: string, customer = 'all') {
  const getToken = useApiToken()
  return useQuery({
    queryKey: ['analytics', days, customer],
    queryFn: async () => {
      const token = await getToken()
      return analyticsApi.get(token, days, customer)
    },
  })
}
